import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Badge } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const SuggestSignalsFromDealsChip = () => {
    const { translate } = useTranslate();

    return (
        <Flex
            alignItems="center"
            gap="8px"
            padding="8px 16px"
            borderRadius="69px"
            border={`1px solid ${colorsPalettes.carbon[50]}`}
            background={colorsPalettes.carbon[0]}
            whiteSpace="nowrap"
            data-automation="account-signals-suggest-from-deals"
        >
            <SWReactIcons
                iconName="sparkles-ai-2"
                iconColor={colorsPalettes.carbon[300]}
                size="sm"
            />
            <Text
                fontVariant="button"
                color={colorsPalettes.carbon[300]}
            >
                {translate("si.account-signals.management.suggest.from.deals.text")}
            </Text>
            <Badge type="coming soon" />
        </Flex>
    );
};
